import { render, staticRenderFns } from "./Lgx02714444011560346059001.vue?vue&type=template&id=8b53c0aa&"
import script from "./Lgx02714444011560346059001.vue?vue&type=script&lang=js&"
export * from "./Lgx02714444011560346059001.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02714444011560346059001.vue?vue&type=style&index=0&id=8b53c0aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports